import { render } from "./FaceImage.vue?vue&type=template&id=35664356&scoped=true"
import script from "./FaceImage.vue?vue&type=script&lang=ts"
export * from "./FaceImage.vue?vue&type=script&lang=ts"

import "./FaceImage.vue?vue&type=style&index=0&id=35664356&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35664356"

export default script